import { jsx as d } from "react/jsx-runtime";
const h = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAqCAYAAAAqAaJlAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQeSURBVHgB1ZlZTtxAEIbLw7ALMIhdQniEQIIHmJyAyQkCJwg5AeQEDCcInCBwAsgJgBNk8oDEC2A2iUUQA2KR2FJ/Y48aM7a7x/ZDPqmx8bTtf6qru6prDIrB3t6elc1mv7y+vubR+JLJzZK62IZh2Hx0+Ljx9PS0mcvlSlQlBmnCAk0WOPvy8jLjE6aKnclklln4Cgu3dW5UFiuJnKM3C8aGrb38/Py8oCpaSezh4SFEFikhkT5sfvYSC16M6hgqFtasqalZZX8sUMqwldfYyt/DrBwoFpOHfWudFP3y8fGRzs/P6eHhAS+mpqYmamtro4aGBtIAVv4cJNiIK5StTgcHB3R0dERsmfcPZ9EDAwM0ODgozuMKNuIIhTW3trbo+vo6tF9zczNNTEwQT1CKIzjj78VCV0lx6PmLRQoFt7e3tLOzQxpYPFd++i++E8uzfp4PeVLg/v6eTk5OSJXT01MhWhVMajZGUb5WFovhd5cnJTCZdLm8vNTqz6M8D13l/6UPiqSBjpXi3CO7gxDrqv9KGmjM7jI8cqSL6w4FnAuxulYFjY2NpAtWhSqZwh/PDSZJk46ODtKls7OTqoGNKUY945rYIk1aWlq0BHd3d8exrAmdsGyBqmRkZEQpnKKPZVkUk0KGZ5u2C3jU1dXR+Pg4tbe3B/YxTVNEL80coRJ5Y39//zcpBoIwrq6uRLu7uxP/I5GB0NbWVkoIG8HaogRAhoWWIiZ8No2EOg3MDP1HwA0cSsi6vAkUDdTW1iJUUoI4VYtFLosJdXNzIxriPq7JQDDWVqzJmGyIejFWBTvLMb7E8ddSvcNxHOIVRAiNAuLRH43TT3ENk7C/v5+6urpIB9boZHkr8ofD2VRUZ1hvd3dXSWQY3hKHrdDY2JhyjsFiNw0Rxt62MYEcHx8LodhvJQ1vXcQ+LQpsc0Sex8P6lwL89uzsjLa3tylNRkdHo9zC5k1nTixdrHolsJdtU9pg1MJAnQxHb51dq9QJybJ/e50GcK+w96DEhKMQy36z4amXYV+moaEhShv4bdCajHqYtyUvRzBW/61SZ+ShKFKkBZ7d09MT+LlnVVAWC/U87AtBD0xDcNRzoUcudHzY9fH6tx5UiEOdAIUNf6TSBZUZuFeYRZkSf5FP7+7z94A7BJWPent7RdhEdeXi4oJ0wY4Y9w8PD0eFXYzy9If7K/VUqXehWohgAdE4D6O+vl5Ysa+vT5xHoF6Y0xHsgd0BEhmUlJB1YSlCEgNhmmVP/ZKnLJiXlB/88sjcIS78jg1u0yzUCeqjVFZh0XNs5VlKaAvkw3FnfbwyvYxbYip6BYcEgMglPi6GWVOmmp+WLD7MuKIt0sd2cxFlkR761TUJFp7nNXPSXZdNN4m3pC42kmb+YiUk+Tz5fun+9iXzD2ItBaoN1O0WAAAAAElFTkSuQmCC";
function m({ name: A, size: t, ...l }) {
  const e = u(A, { size: t });
  return /* @__PURE__ */ d(
    "img",
    {
      src: e.url,
      alt: A,
      width: e.width,
      height: e.height,
      ...l
    }
  );
}
function u(A, { size: t = 50, fontFamily: l = "sans-serif" } = {}) {
  if (A == null || A.trim() === "")
    return {
      url: h,
      width: t,
      height: t
    };
  const e = t / 2, r = A.trim().split(/\s+/).slice(0, 2).map((a) => a[0].toUpperCase()).join(""), { textColor: c, backgroundColor: s } = g(A), i = document.createElement("canvas"), n = window.devicePixelRatio || 1;
  i.width = t * n, i.height = t * n;
  const o = i.getContext("2d");
  return o.scale(n, n), o.font = `${e}px ${l}`, o.textAlign = "center", o.textBaseline = "middle", o.fillStyle = s, o.fillRect(0, 0, t, t), o.fillStyle = c, o.fillText(r.slice(0, 2), t / 2, t / 2), {
    url: i.toDataURL(),
    width: t,
    height: t
  };
}
function g(A) {
  const t = A.split("").reduce((n, o) => {
    const a = o.charCodeAt(0);
    return (n << 5) - n + a | 0;
  }, 0), l = Math.abs(t), e = l % 360, r = 45 + l % 25, c = 65 + l % 10;
  return { backgroundColor: `hsl(${e}, ${r}%, ${c}%)`, textColor: "#000" };
}
export {
  m as default,
  u as getAvatarFromName
};
